<template>
  <section>
    <div :class="['be-loading', { 'be-loading-active': isBusy }]">
      <div class="">
        <div class="table-responsive">
          <table class="table m-0 p-0 dataTable text-nowrap min-h-[150px]">
            <thead class="bg-white">
              <tr>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Channel
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Bank/Provider Name
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  AccountNumber/ID
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Status
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Created
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                    <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                    <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px">
                      Please wait while we load the list
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="l in PaymentChannels" :key="l.id" v-else>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  {{ l.paymentChannelTypeName }}
                </td>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  {{
                    (l.paymentChannelTypeName &&
                      l.paymentChannelTypeName.toLowerCase() === "bank") ||
                      (l.paymentChannelTypeName &&
                        l.paymentChannelTypeName.toLowerCase() === "pos") ||
                      (l.paymentChannelTypeName &&
                        l.paymentChannelTypeName.toLowerCase() ===
                        "cryptocurrency")
                      ? l.bankName
                      : "NA"
                  }}
                </td>
                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  {{
                    l.paymentChannelTypeName &&
                      l.paymentChannelTypeName.toLowerCase() === "bank"
                      ? l.accountNumber
                      : l.paymentChannelTypeName &&
                        l.paymentChannelTypeName.toLowerCase() === "pos"
                        ? l.terminalId
                        : l.paymentChannelTypeName &&
                          l.paymentChannelTypeName.toLowerCase() ===
                          "cryptocurrency"
                          ? l.walletAddress
                          : "NA"
                  }}
                </td>
                <td>
                  <span :class="[
                    'badge badge-pill flex items-center gap-[4px] max-w-max px-[4px]',
                    l.active ? 'badge-success' : 'badge-danger',
                  ]">
                    <span class="w-[10px] h-[10px] rounded-[1px]"
                      :class="l.active ? 'bg-[#16a249]' : 'bg-[#DC2828]'"></span>
                    <span class="text-[12px] font-normal leading-[16.94px]">
                      {{ l.active ? "Active" : "Inactive" }}
                    </span>
                  </span>
                </td>

                <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                  {{ formatDate(l.created) }}
                </td>
                <td>
                  <div class="dropdown">
                    <button class="btn-no-border" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      <span
                        class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none">...</span>
                    </button>
                    <ul class="dropdown-menu shadow-none" aria-labelledby="dropdownMenuButton">
                      <li v-if="
                        hasPermission('Payment_Channels_Update') &&
                        l.parentId == user.parentId
                      " @click.prevent="viewEdit(l)"
                        class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b">
                        Edit
                      </li>
                      <li @click.prevent="makeDefault(l)"
                        class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                        v-if="
                          hasPermission('Payment_Channels_Update') &&
                          l.paymentChannelTypeName == 'BANK' &&
                          l.isDefault === false
                        ">
                        Make default bank
                      </li>
                      <li v-if="hasPermission('Payment_Channels_Delete')" @click.prevent="confirmDelete(l.id)"
                        class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[10px] px-[16px]">
                        Delete Channel
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr v-if="!PaymentChannels.length && !loading">
                <td colspan="6">
                  <div class="text-center" style="padding-top: 50px">
                    <span style="font-size: 4.615rem" class="mdi mdi-crosshairs-gps"></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    You don't have any payment channels.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :limit="pageSize" :count="pageCount" :page="pageNumber" :itemsCount="count" @changePage="gotoPage"
            @changeLimit="changeLimit" />
        </div>
      </div>
    </div>
    <!-- add modal -->
    <div class="modal fade" id="mod-add" role="dialog">
      <div class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end">
        <div class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]">
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]">
              Create new payment channel
            </h4>
            <button class="text-2xl text-[#353535] outline-none focus:outline-none" type="button" data-dismiss="modal"
              aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Payment Channel</label>
              <div>
                <select placeholder="Select an option"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[
                    {
                      'is-invalid': v1.paymentChannel,
                    },
                  ]" v-model="createPaymentChannel.paymentChannel">
                  <option v-for="(p, index) in channels" :key="index" :value="p.name">
                    {{ p.name }}
                  </option>
                </select>
                <span v-if="v1.paymentChannel" class="invalid-feedback">
                  Please select a payment channel.
                </span>
              </div>
            </div>
            <div v-if="createPaymentChannel.paymentChannel.toLowerCase() === 'pos'">
              <div class="mb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Terminal Issuer</label>
                <div>
                  <multiselect v-model="posCreateSelect" label="name" track-by="code" :options="bankLists"
                    @select="onSelectCreatePosPay"></multiselect>
                  <span v-if="v1.pos.bank" class="invalid-feedback">
                    Terminal issuer is required.
                  </span>
                </div>
              </div>
              <div class="mb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Terminal/Device Id</label>
                <div>
                  <div class="">
                    <input
                      class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                      :class="[
                        {
                          'is-invalid': v1.pos.terminalId,
                        },
                      ]" v-model.trim="createPaymentChannel.pos.terminalId" @blur="validateTerminal('create')"
                      placeholder="Enter terminal id" />

                    <span v-if="v1.pos.terminalId" class="invalid-feedback">
                      Please enter a unique terminal Id.
                    </span>
                  </div>
                  <div class="col-2">
                    <span v-if="isTerminalValid" class="mdi mdi-check text-success"></span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="
              createPaymentChannel.paymentChannel.toLowerCase() ===
              'cryptocurrency'
            ">
              <div class="mb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Provider</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid': v1.crypto.provider,
                      },
                    ]" type="text" v-model.trim="createPaymentChannel.crypto.provider" placeholder="Enter provider" />
                  <span v-if="v1.crypto.provider" class="invalid-feedback">
                    Please enter a provider.
                  </span>
                </div>
              </div>
              <div class="mb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Wallet Address</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid': v1.crypto.walletAddress,
                      },
                    ]" type="text" v-model.trim="createPaymentChannel.crypto.walletAddress"
                    placeholder="Enter wallet address" />
                  <span v-if="v1.crypto.walletAddress" class="invalid-feedback">
                    Please enter a wallet Address.
                  </span>
                </div>
              </div>
            </div>
            <div v-if="
              createPaymentChannel.paymentChannel.toLowerCase() === 'bank'
            ">
              <div class="pb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Bank</label>
                <div>
                  <multiselect v-model="bankCreateSelect" label="name" track-by="code" :options="bankLists"
                    @select="onSelectCreateBankPay"></multiselect>
                  <span v-if="v1.bank.name" class="invalid-feedback">
                    Bank is required.
                  </span>
                </div>
              </div>

              <div class="mb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Account Number</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid':
                          v1.bank.accountNumber || v1.bank.accountNumberValid,
                      },
                    ]" type="text" v-model="createPaymentChannel.bank.accountNumber" />
                  <span v-if="v1.bank.accountNumber" class="invalid-feedback">
                    Account is required.
                  </span>
                  <span v-if="v1.bank.accountNumberValid" class="invalid-feedback">
                    Enter a valid account number.
                  </span>
                </div>
              </div>

              <div class="mb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Account Name</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid': v1.bank.accountName,
                      },
                    ]" type="text" disabled v-model="createPaymentChannel.bank.accountName" />
                  <span v-if="v1.bank.accountName" class="invalid-feedback">
                    Account Name is required.
                  </span>
                </div>
              </div>
              <div class="mb-[16px]">
                <div class="flex items-center gap-[10px] max-w-max" @click="
                  createPaymentChannel.isDefault = !createPaymentChannel.isDefault
                  ">
                  <button type="button"
                    class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                    role="switch" :aria-checked="createPaymentChannel.isDefault" :class="{
                      'bg-[#2463eb]': createPaymentChannel.isDefault,
                      'bg-[#E4E4E7]': !createPaymentChannel.isDefault,
                    }">
                    <span aria-hidden="true"
                      class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                      :class="{
                        'translate-x-5 bg-white':
                          createPaymentChannel.isDefault,
                        'translate-x-0 bg-gray-400': !createPaymentChannel.isDefault,
                      }"></span>
                  </button>
                  <span class="cursor-pointer">
                    <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                      Make default bank account
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-[16px]">
              <div class="flex items-center gap-[10px] max-w-max" @click="
                createPaymentChannel.active = !createPaymentChannel.active
                ">
                <button type="button"
                  class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                  role="switch" :aria-checked="createPaymentChannel.active" :class="{
                    'bg-[#2463eb]': createPaymentChannel.active,
                    'bg-[#E4E4E7]': !createPaymentChannel.active,
                  }">
                  <span aria-hidden="true"
                    class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                    :class="{
                      'translate-x-5 bg-white': createPaymentChannel.active,
                      'translate-x-0 bg-gray-400': !createPaymentChannel.active,
                    }"></span>
                </button>
                <span class="cursor-pointer">
                  <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                    This channel is active
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" @click.prevent="create">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- edit modal -->
    <div class="modal fade" id="mod-edit" role="dialog">
      <div class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end">
        <div class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]">
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]">
              Edit Payment Channel
            </h4>
            <button class="text-2xl text-[#353535] outline-none focus:outline-none" type="button" data-dismiss="modal"
              aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="p-0 m-0">
            <div class="pb-[16px]">
              <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Payment Channel</label>
              <div>
                <select placeholder="Select an option" disabled
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[
                    {
                      'is-invalid': v2.paymentChannel,
                    },
                  ]" v-model="updatePaymentChannel.paymentChannel">
                  <option v-for="(p, index) in channels" :key="index" :value="p.name">
                    {{ p.name }}
                  </option>
                </select>
                <span v-if="v2.paymentChannel" class="invalid-feedback">
                  Please select a payment channel.
                </span>
              </div>
            </div>
            <div v-if="updatePaymentChannel.paymentChannel.toLowerCase() === 'pos'">
              <div class="pb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Terminal Issuer</label>
                <div>
                  <multiselect v-model="posUpdateSelect" label="name" track-by="code" :options="bankLists"
                    @select="onSelectUpdatePosPay"></multiselect>
                  <span v-if="v2.pos.bank" class="invalid-feedback">
                    Issuer is required.
                  </span>
                </div>
              </div>
              <div class="pb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Terminal/Device Id</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid': v2.pos.terminalId,
                      },
                    ]" type="number" v-model.trim="updatePaymentChannel.pos.terminalId"
                    placeholder="Enter terminal id" />

                  <span v-if="v2.pos.terminalId" class="invalid-feedback">
                    Please enter a terminal Id.
                  </span>
                </div>
              </div>
            </div>
            <div v-if="
              updatePaymentChannel.paymentChannel.toLowerCase() ===
              'cryptocurrency'
            ">
              <div class="pb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Provider</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid': v2.crypto.provider,
                      },
                    ]" type="text" v-model.trim="updatePaymentChannel.crypto.provider" placeholder="Enter provider" />
                  <span v-if="v2.crypto.provider" class="invalid-feedback">
                    Please enter a provider.
                  </span>
                </div>
              </div>
              <div class="pb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Wallet Address</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid': v2.crypto.walletAddress,
                      },
                    ]" type="text" v-model.trim="updatePaymentChannel.crypto.walletAddress"
                    placeholder="Enter wallet address" />
                  <span v-if="v2.crypto.walletAddress" class="invalid-feedback">
                    Please enter a wallet Address.
                  </span>
                </div>
              </div>
            </div>

            <div v-if="
              updatePaymentChannel.paymentChannel.toLowerCase() === 'bank'
            ">
              <div class="pb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Bank</label>
                <div>
                  <multiselect v-model="bankUpdateSelect" label="name" track-by="code" :options="bankLists"
                    @select="onSelectUpdateBankPay"></multiselect>
                  <span v-if="v2.bank.name" class="invalid-feedback">
                    Bank is required.
                  </span>
                </div>
              </div>
              <div class="pb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Account Name</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid': v2.bank.accountName,
                      },
                    ]" type="text" v-model="updatePaymentChannel.bank.accountName" />
                  <span v-if="v2.bank.accountName" class="invalid-feedback">
                    Account Name is required.
                  </span>
                </div>
              </div>
              <div class="mb-[16px]">
                <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Account Number</label>
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :class="[
                      {
                        'is-invalid':
                          v2.bank.accountNumber || v2.bank.accountNumberValid,
                      },
                    ]" type="text" v-model="updatePaymentChannel.bank.accountNumber" />
                  <span v-if="v2.bank.accountNumber" class="invalid-feedback">
                    Account is required.
                  </span>
                  <span v-if="v2.bank.accountNumberValid" class="invalid-feedback">
                    Enter a valid account number.
                  </span>
                </div>
              </div>
              <div class="pb-[16px]">
                <div class="flex items-center gap-[10px] max-w-max" @click="
                  updatePaymentChannel.isDefault = !updatePaymentChannel.isDefault
                  ">
                  <button type="button"
                    class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                    role="switch" :aria-checked="updatePaymentChannel.isDefault" :class="{
                      'bg-[#2463eb]': updatePaymentChannel.isDefault,
                      'bg-[#E4E4E7]': !updatePaymentChannel.isDefault,
                    }">
                    <span aria-hidden="true"
                      class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                      :class="{
                        'translate-x-5 bg-white':
                          updatePaymentChannel.isDefault,
                        'translate-x-0 bg-gray-400': !updatePaymentChannel.isDefault,
                      }"></span>
                  </button>
                  <span class="cursor-pointer">
                    <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                      Make default bank account
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div class="pb-[16px]">
              <div class="flex items-center gap-[10px] max-w-max" @click="
                updatePaymentChannel.active = !updatePaymentChannel.active
                ">
                <button type="button"
                  class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                  role="switch" :aria-checked="updatePaymentChannel.active" :class="{
                    'bg-[#2463eb]': updatePaymentChannel.active,
                    'bg-[#E4E4E7]': !updatePaymentChannel.active,
                  }">
                  <span aria-hidden="true"
                    class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                    :class="{
                      'translate-x-5 bg-white': updatePaymentChannel.active,
                      'translate-x-0 bg-gray-400': !updatePaymentChannel.active,
                    }"></span>
                </button>
                <span class="cursor-pointer">
                  <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                    This channel is active
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" @click.prevent="update">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- filter modal -->
    <div class="modal fade" id="mod-filter" role="dialog">
      <div class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end">
        <div class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]">
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h3 class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]">
              Filter
            </h3>
            <button class="text-2xl text-[#353535] outline-none focus:outline-none" type="button" data-dismiss="modal"
              aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Status</label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option" v-model="filter.status">
                  <option value="0">All Payment Channels</option>
                  <option value="True">Active</option>
                  <option value="False">Disabled</option>
                </select>
              </div>
            </div>

            <div>
              <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Other filters</label>
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text" placeholder="Filter by name..." v-model="filter.qry" />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" @click="reset">
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" @click="getPaymentChannels">
              {{ isBusy ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution :id="DeleteId" @proceed="deleteChannel" :isBusy="isBusyModal" text="payment channel" />
    <GeneralDeleteMessage message="You cannot delete this Payment Channel because there are payments or 
      posting transactions associated with it. Consider disabling it instead." />
  </section>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import GeneralDeleteMessage from "../GeneralDeleteMessage.vue";
import GeneralDeleteCaution from "../GeneralDeleteCaution.vue";
import SystemPermissions from "@/permissions";
import Pagination from "../Pagination.vue";
import Multiselect from "vue-multiselect";
import { bus } from "../../main";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsPaymentChannels",
  components: {
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
    Multiselect,
  },

  created() {
    this.getBankLists();
    this.getPaymentChannels();
    this.getChannelTypes();
    bus.$on("viewAdd", this.viewAdd);
    bus.$on("viewFilter", this.viewFilter);
  },

  data() {
    return {
      filter: {
        status: "0",
        qry: "",
        channel: "",
      },

      banks: helper.getBanks(),
      bankCodes: helper.getBankCodes(),
      loading: true,
      isBusy: false,
      isBusyModal: false,
      createPaymentChannel: {
        paymentChannel: "",
        active: false,
        isDefault: false,
        bank: {
          name: "",
          accountName: "",
          accountNumber: "",
        },

        crypto: {
          provider: "",
          walletAddress: "",
        },

        pos: {
          bank: "",
          terminalId: "",
        },
      },

      updatePaymentChannel: {
        paymentChannel: "",
        active: false,
        bank: {
          name: "",
          accountName: "",
          accountNumber: "",
        },

        crypto: {
          provider: "",
          walletAddress: "",
        },

        pos: {
          bank: "",
          terminalId: "",
        },
      },

      v1: {
        paymentChannel: false,
        bank: {
          name: false,
          accountName: false,
          accountNumber: false,
          accountNumberValid: false,
        },

        crypto: {
          provider: false,
          walletAddress: false,
        },

        pos: {
          bank: false,
          terminalId: false,
        },
      },

      v2: {
        paymentChannel: false,
        bank: {
          name: false,
          accountName: false,
          accountNumber: false,
          accountNumberValid: false,
        },

        crypto: {
          provider: false,
          walletAddress: false,
        },

        pos: {
          bank: false,
          terminalId: false,
        },
      },
      bankLists: [],
      channels: [],
      PaymentChannels: [],
      DeleteId: "",
      count: 0,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      bankCreateSelect: "",
      bankUpdateSelect: "",
      posCreateSelect: "",
      posUpdateSelect: "",
      isTerminalValid: false,
    };
  },

  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    bankName() {
      return `${this.createPaymentChannel.bank.name}`;
    },
    bankAccount() {
      return `${this.createPaymentChannel.bank.accountNumber}`;
    },
  },

  watch: {
    bankName(newValue, oldValue) { },
    bankAccount(newValue, oldValue) {
      if (newValue.length == 10) {
        let bankCode = this.bankLists.filter(
          (el) => el.name === this.bankCreateSelect.name
        )[0].code;
        this.validatebankAccount(newValue, bankCode);
      }
    },
  },

  methods: {
    async validateTerminal(type) {
      this.isBusy = true;
      this.v1.pos.terminalId = false;
      this.isTerminalValid = false;
      let terminalId =
        type === "create"
          ? this.createPaymentChannel.pos.terminalId
          : this.updatePaymentChannel.pos.terminalId;

      try {
        const response = await this.$http.get(
          `/PaymentChannels/posTerminalUnique?terminalId=${terminalId}`
        );
        if (response.ok) {
          // if (response.body) {
          this.isTerminalValid = response.body;
          this.v1.pos.terminalId = !response.body;
          // }
          this.isBusy = false;
        }
      } catch (err) {
        this.$toast.info(err, {
          icon: true,
          rtl: false,
        });
      }
    },
    async validatebankAccount(accountnumber, code) {
      this.isBusy = true;
      // let body = {
      // 	accountNo: accountnumber,
      // 	bankCode: code,
      // };
      try {
        const response = await this.$http.post(
          `/Payments/accountValidation?accountNo=${accountnumber}&bankCode=${code}`
        );
        if (response.ok) {
          if (response.body.status == "Account Not Found") {
            this.$toast.error(response.body.message, {
              icon: true,
              rtl: false,
            });

            this.isBankAccountValid = true;
            this.createPaymentChannel.bank.accountName =
              response.body.data.account_name;
            return;
          }
          this.$toast.success(response.body.message, {
            icon: true,
            rtl: false,
          });
          // this.accountName = data.data.accounnt_name;
          this.isBusy = false;
          this.createPaymentChannel.bank.accountName =
            response.body.data.account_name;
          this.isBankAccountValid = true;
        }
      } catch (err) {
        this.$toast.info(err, {
          icon: true,
          rtl: false,
        });
      }
    },
    reset() {
      this.filter = {
        status: "0",
        qry: "",
        channel: 0,
      };
    },

    onSelectCreateBankPay(option) {
      this.createPaymentChannel.bank.name = option.name;
    },

    onSelectCreatePosPay(option) {
      this.createPaymentChannel.pos.bank = option.name;
    },

    onSelectUpdateBankPay(option) {
      this.updatePaymentChannel.bank.name = option.name;
    },

    onSelectUpdatePosPay(option) {
      this.updatePaymentChannel.pos.bank = option.name;
    },

    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteChannel() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(
          `/PaymentChannels/${this.DeleteId}`
        );
        if (res.ok) {
          this.$toast.success("Payment channel deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getPaymentChannels();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },

    viewAdd() {
      this.createPaymentChannel = {
        paymentChannel: "",
        active: false,
        isDefault: false,
        bank: {
          name: "",
          accountName: "",
          accountNumber: "",
        },

        crypto: {
          provider: "",
          walletAddress: "",
        },

        pos: {
          bank: "",
          terminalId: "",
        },
      };

      this.v1 = {
        paymentChannel: false,
        bank: {
          name: false,
          accountName: false,
          accountNumber: false,
          accountNumberValid: false,
        },

        crypto: {
          provider: false,
          walletAddress: false,
        },

        pos: {
          bank: false,
          terminalId: false,
        },
      };
      $("#mod-add").modal("show");
    },

    viewEdit(c) {
      this.updatePaymentChannel.paymentChannel = c.paymentChannelTypeName;
      this.updatePaymentChannel.id = c.id;
      this.updatePaymentChannel.crypto.provider = c.bankName;
      this.updatePaymentChannel.crypto.walletAddress = c.walletAddress;
      this.updatePaymentChannel.pos.terminalId = c.terminalId;
      this.updatePaymentChannel.pos.bank = c.bankName;
      this.updatePaymentChannel.bank.name = c.bankName;
      this.updatePaymentChannel.bank.accountName = c.accountName;
      this.updatePaymentChannel.bank.accountNumber = c.accountNumber;
      this.updatePaymentChannel.active = c.active;
      this.updatePaymentChannel.isDefault = c.isDefault;
      $("#mod-edit").modal("show");
    },

    async makeDefault(c) {
      this.updatePaymentChannel.paymentChannel = c.paymentChannelTypeName;
      this.updatePaymentChannel.id = c.id;
      this.updatePaymentChannel.crypto.provider = c.bankName;
      this.updatePaymentChannel.crypto.walletAddress = c.walletAddress;
      this.updatePaymentChannel.pos.terminalId = c.terminalId;
      this.updatePaymentChannel.pos.bank = c.bankName;
      this.updatePaymentChannel.bank.name = c.bankName;
      this.updatePaymentChannel.bank.accountName = c.accountName;
      this.updatePaymentChannel.bank.accountNumber = c.accountNumber;
      this.updatePaymentChannel.active = c.active;
      this.updatePaymentChannel.isDefault = true;

      this.update();
    },

    viewFilter() {
      $("#mod-filter").modal("show");
    },

    async getChannelTypes() {
      this.isBusyModal = true;
      this.isBusy = true;
      try {
        const response = await this.$http.get("/PaymentChannelType/list");
        if (response.ok) this.channels = response.body;
      } catch (error) { }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    async getBankLists() {
      this.isBusyModal = true;
      this.isBusy = true;
      try {
        const response = await this.$http.get("/Payments/getbanks");
        if (response.ok) this.bankLists = response.body;
      } catch (error) {
        console.log(error);
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    async create() {
      if (this.validateCreate()) {
        this.isBusyModal = true;
        this.isBusy = true;
        let bankCode = "";
        let bankName = "";
        // if (this.createPaymentChannel.paymentChannel == "BANK") {
        // 	bankCode = this.bankLists.filter((el) => el.name === this.createPaymentChannel.bank.name)[0].code;
        // }
        if (this.createPaymentChannel.paymentChannel == "BANK") {
          bankCode = this.bankLists.filter(
            (el) => el.name === this.createPaymentChannel.bank.name
          )[0].code;
        }

        const data = {
          ...this.createPaymentChannel,
          bank:
            this.createPaymentChannel.paymentChannel == "BANK"
              ? {
                ...this.createPaymentChannel.bank,
                bankCode,
              }
              : this.createPaymentChannel.bank,
          parentId: this.user.parentId,
        };

        await this.$http
          .post("/PaymentChannels/create", data)
          .then(function (res) {
            this.isBusyModal = false;
            this.$toast.success("Payment channel created successfully.", {
              icon: false,
              rtl: false,
            });
            $("#mod-add").modal("hide");
          })
          .catch(function () { });

        this.getPaymentChannels();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateCreate() {
      this.v1 = {
        paymentChannel: false,
        bank: {
          name: false,
          accountName: false,
          accountNumber: false,
          accountNumberValid: false,
        },

        crypto: {
          provider: false,
          walletAddress: false,
        },

        pos: {
          bank: false,
          terminalId: false,
        },
      };

      let isValid = true;

      if (!this.createPaymentChannel.paymentChannel) {
        this.v1.paymentChannel = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() === "pos" &&
        !this.createPaymentChannel.pos.terminalId &&
        !this.isTerminalValid
      ) {
        this.v1.pos.terminalId = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() === "pos" &&
        !this.createPaymentChannel.pos.bank
      ) {
        this.v1.pos.bank = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() ===
        "cryptocurrency" &&
        !this.createPaymentChannel.crypto.provider
      ) {
        this.v1.crypto.provider = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() ===
        "cryptocurrency" &&
        !this.createPaymentChannel.crypto.walletAddress
      ) {
        this.v1.crypto.walletAddress = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        !this.createPaymentChannel.bank.name
      ) {
        this.v1.bank.name = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        !this.createPaymentChannel.bank.accountNumber
      ) {
        this.v1.bank.accountNumber = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        !this.createPaymentChannel.bank.accountName
      ) {
        this.v1.bank.accountName = true;
        isValid = false;
      }

      if (
        this.createPaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        this.createPaymentChannel.bank.accountNumber &&
        !helper.validateNuban(this.createPaymentChannel.bank.accountNumber)
      ) {
        this.v1.bank.accountNumberValid = true;
        isValid = false;
      }

      return isValid;
    },

    async update() {
      this.isBusyModal = true;
      this.isBusy = true;
      let bankCode = "";
      if (this.updatePaymentChannel.paymentChannel == "BANK") {
        bankCode = this.bankLists.filter(
          (el) => el.name === this.updatePaymentChannel.bank.name
        )[0].code;
      }

      const data = {
        ...this.updatePaymentChannel,
        bank:
          this.updatePaymentChannel.paymentChannel == "BANK"
            ? {
              ...this.updatePaymentChannel.bank,
              bankCode,
            }
            : this.updatePaymentChannel.bank,
      };

      if (this.validateUpdate()) {
        await this.$http
          .put("/PaymentChannels/update/" + data.id, data)
          .then(function (res) {
            this.isBusyModal = false;
            this.$toast.success("Payment channel updated successfully.", {
              icon: false,
              rtl: false,
            });
          })
          .catch(function () { });
        $("#mod-edit").modal("hide");
        this.getPaymentChannels();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateUpdate() {
      this.v2 = {
        paymentChannel: false,
        bank: {
          name: false,
          accountName: false,
          accountNumber: false,
          accountNumberValid: false,
        },

        crypto: {
          provider: false,
          walletAddress: false,
        },

        pos: {
          bank: false,
          terminalId: false,
        },
      };

      var isValid = true;

      if (!this.updatePaymentChannel.paymentChannel) {
        this.v2.paymentChannel = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() === "pos" &&
        !this.updatePaymentChannel.pos.terminalId &&
        !this.isTerminalValid
      ) {
        this.v2.pos.terminalId = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() === "pos" &&
        !this.updatePaymentChannel.pos.bank
      ) {
        this.v2.pos.bank = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() ===
        "cryptocurrency" &&
        !this.updatePaymentChannel.crypto.provider
      ) {
        this.v2.crypto.provider = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() ===
        "cryptocurrency" &&
        !this.updatePaymentChannel.crypto.walletAddress
      ) {
        this.v2.crypto.walletAddress = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        !this.updatePaymentChannel.bank.name
      ) {
        this.v2.bank.name = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        !this.updatePaymentChannel.bank.accountNumber
      ) {
        this.v2.bank.accountNumber = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        !this.updatePaymentChannel.bank.accountName
      ) {
        this.v2.bank.accountName = true;
        isValid = false;
      }

      if (
        this.updatePaymentChannel.paymentChannel.toLowerCase() === "bank" &&
        this.updatePaymentChannel.bank.accountNumber &&
        !helper.validateNuban(this.updatePaymentChannel.bank.accountNumber)
      ) {
        this.v2.bank.accountNumberValid = true;
        isValid = false;
      }

      return isValid;
    },

    async getPaymentChannels() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/PaymentChannels/getList?pageNumber=" +
          (this.pageNumber - 1) +
          "&PaymentChannel=" +
          this.filter.qry +
          "&pageSize=" +
          this.pageSize +
          (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
          (this.filter.qry != ""
            ? "&PaymentChannel=" + this.filter.qry
            : "") +
          (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function (res) {
          this.PaymentChannels = res.body.data;
          this.pageNumber = res.body.pageNumber + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function () {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    prev() {
      this.pageNumber -= 1;
      this.getPaymentChannels();
    },

    next() {
      this.pageNumber += 1;
      this.getPaymentChannels();
    },

    gotoPage(page) {
      this.pageNumber = page;
      this.getPaymentChannels();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.pageNumber = 1;
      this.getPaymentChannels();
    },
  },
};
</script>
